import styled from 'styled-components'
import { theme } from 'styles/theme'

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;

  background-color: ${theme.colors.primaryBlack};
  color: ${theme.colors.white};

  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`
